export function tabGroup() {
	return {
		current_tab: null,
		is_open(slug) {
			return this.current_tab === slug;
		},
		open_tab(slug) {
			this.current_tab = slug;
		},
		close_tabs() {
			this.current_tab = null;
		},
		tabTemplate(slug, type) {
			const result = {
				[':class']() {
					return {
						'current': this.is_open(slug),
					}
				}
			}

			switch (type) {
				case 'toggle':
					result['@click.prevent'] = function () {
						this.current_tab = this.is_open(slug) ? null : slug;
					};
					break;
				default:
					result['@click.prevent'] = function () {
						this.current_tab = slug;
					};
					break;
			}

			return result;
		},
		panelTemplate(slug, open = false) {
			open && this.open_tab(slug);

			return {
				['x-show']() {
					return this.is_open(slug);
				}
			}
		},
	}
}